import { salvarSimulacao } from "~pages/Simulators/hooks/SimulatorsServices";

import {
  atualizarEmissor,
  atualizarProspect,
  atualizarRecebedor,
  salvarBuscaOnline,
  salvarConversao,
  salvarEmissor,
  salvarLimite,
  salvarProspect,
  salvarRecebedor,
} from "~services/WalletServices";

const mutationsFunctions = {
  "Salvar Prospect": salvarProspect,
  "Atualizar Prospect": atualizarProspect,
  "Atualizar Recebedor": atualizarRecebedor,
  "Salvar Recebedor": salvarRecebedor,
  "Salvar Simulação": salvarSimulacao,
  "Salvar Conversão": salvarConversao,
  "Atualizar Emissor": atualizarEmissor,
  "Salvar Emissor": salvarEmissor,
  "Salvar Busca Online": salvarBuscaOnline,
  "Salvar Limite": salvarLimite,
};

export default mutationsFunctions;
